import { createSelector, createFeatureSelector } from '@ngrx/store';

import { FeatureState } from '../../models';
import { adapter } from '../reducers/feature.reducer';

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const getFeatureState = createFeatureSelector<FeatureState>('app-feature');

export const getFeatures = createSelector(getFeatureState, selectAll);

export const getLastYearsFeatures = createSelector(
  getFeatureState,
  (store) => store.lastYearsFeatures ?? [],
);

export const getModifyingFeature = createSelector(getFeatureState, (store) =>
  store.modifyingFeature ? store.modifyingFeature : null,
);

export const getSelectedRvoIds = createSelector(getFeatureState, (store) =>
  store.selectedRvoIds ? store.selectedRvoIds : [],
);

export const getSelectedRvoFeatures = createSelector(getFeatureState, (store) =>
  store.selectedRvoIds ? store.selectedRvoFeatures : [],
);

export const getSelectedLastYearsFeatures = createSelector(getFeatureState, (store) =>
  store.selectedLastYearsFeatures ? store.selectedLastYearsFeatures : [],
);

export const getSelectedFeaturesIds = createSelector(getFeatureState, (store) =>
  store.selectedFeaturesIds ? store.selectedFeaturesIds : [],
);

export const getAllFeatureIds = createSelector(getFeatures, (features) =>
  features.map(({ id }) => id),
);

export const getSelectedFeatures = createSelector(
  getFeatures,
  getSelectedFeaturesIds,
  (features, ids) => features.filter(({ id }) => ids.indexOf(id) !== -1),
);

export const hasSelectedFeatures = createSelector(
  getSelectedFeaturesIds,
  (selectedIds) => selectedIds.length > 0,
);

export const hasSelectedSingleFeature = createSelector(
  getSelectedFeaturesIds,
  (selectedIds) => selectedIds.length === 1,
);

export const hasSelectedTwoFeatures = createSelector(
  getSelectedFeaturesIds,
  (selectedIds) => selectedIds.length === 2,
);

export const hasSelectedMultipleFeatures = createSelector(
  getSelectedFeaturesIds,
  (selectedIds) => selectedIds.length > 1,
);

export const getSelectedFeaturesLength = createSelector(
  getSelectedFeaturesIds,
  (selectedIds) => selectedIds.length,
);

export const getSelectedFeaturesIdsAsNumber = createSelector(
  getSelectedFeaturesIds,
  (selectedIds) => selectedIds.map((id) => parseInt(id, 10)),
);
